export const DEFAULT_LANGUAGES = [
  { value: 'English', label: 'English', code: 'GB' },
  { value: 'Arabic', label: 'Arabic', code: 'n/a' },
  { value: 'Bengali', label: 'Bengali', code: 'n/a' },
  { value: 'Dutch', label: 'Dutch', code: 'AN' },
  { value: 'French', label: 'French', code: 'FR' },
  { value: 'German', label: 'German', code: 'DE' },
  { value: 'Hindi', label: 'Hindi', code: 'n/a' },
  { value: 'Indonesian', label: 'Indonesian', code: 'ID' },
  { value: 'Italian', label: 'Italian', code: 'IT' },
  { value: 'Japanese', label: 'Japanese', code: 'JP' },
  { value: 'Mandarin', label: 'Mandarin', code: 'n/a' },
  { value: 'Polish', label: 'Polish', code: 'PL' },
  { value: 'Portuguese', label: 'Portuguese', code: 'PT' },
  { value: 'Russian', label: 'Russian', code: 'RU' },
  { value: 'Spanish', label: 'Spanish', code: 'ES' },
]

export default function useLanguages() {
  return {
    languages: DEFAULT_LANGUAGES,
    isLoading: false,
    error: null,
  }
}
